import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import { OrderResponse, orderInterface, toOrder } from '../orders';

export default (axios: AxiosInstance = baseAxios): { fetchOrderErrors: () => Promise<orderInterface[]>; resolveOrderErrors: (orderId: number) => Promise<void>; convertUnsellableToDifferentCondition: (unsellableItemId: number, itemId: number) => Promise<void>; } => ({
    fetchOrderErrors: async (): Promise<orderInterface[]> => {
        const response = await axios.get<{ orders: OrderResponse[] }>('/api/orders?filters[status]=error');
        return response.data.orders.map(toOrder);
    },

    resolveOrderErrors: async (orderId: number): Promise<void> => {
        return axios.get(`/api/orders/${orderId}/resolveOrderErrors`);
    },

    convertUnsellableToDifferentCondition: async (unsellableItemId: number, itemId: number): Promise<void> => {
        return axios.post(`/api/shipments/inbound/inbound-shipment-unsellable-item/${unsellableItemId}/convert-to-different-item`, {
            item_id: itemId,
        });
    },
});
